import "./resumo-lateral.css";
import React, { Component } from "react";
import { Typography } from "@material-ui/core";

class ResumoLateral extends Component {
  constructor(props) {
    super(props);

    this.state = {
        open: "",
        arrow: "",
        lab: null,
    };
    this.openSummary = this.openSummary.bind(this);

  }
  openSummary(e) {
    this.setState({ [e.target.id]: e.target.value }, () => {
      if (this.state.open) {
        this.setState({ open: "", arrow: "" });
      } else {
        this.setState({ open: "show-summary", arrow: "active-arrow" });
      }
    });
  }

  render() {
    return (
    <div className={`resumo-lateral_main ${this.state.arrow}`}>
          <div className={`resumo-lateral_summary ${this.state.open}`} >
            <div className={`resumo-lateral_summary--arrowContainer ${this.state.arrow}`} onClick={this.openSummary}>
            <span className={`resumo-lateral_summary--arrow ${this.state.arrow}`} onClick={this.openSummary}></span>
            </div>
            <div className={`resumo-lateral_summary--container ${this.state.arrow}`}>
              <div className="resumo-lateral_summary--intro">
                <div style={{ textAlign: "center" }}>
                  <img
                    src={this.props.logoTransparente}
                    width="45%"
                    className="resumo-lateral_summary--icon"
                    alt="Logo Financeiro"
                  />
                </div>

               { this.props.lab && (
                  <div className="row">
                    <div className="col-12">
                      <Typography variant="subtitle1" style={{ color: "#00518b", fontSize: "1rem", fontWeight: 500 }}>
                        Laboratório:
                      </Typography>
                    </div>
                    <div className="logolabTracking col-12 my-4">
                      <img src={this.props.lab_logo} width="178" height="120" alt="Logo laboratório" />
                    </div>
                    <div className="col-12 mt-3">
                      <Typography variant="subtitle2" style={{ fontWeight: 600, color: "#00518b" }}>
                        Dúvidas? Entre em contato com o laboratório
                      </Typography>
                      {this.props.lab_phone && (
                        <Typography variant="body2" color="textSecondary" style={{ marginTop: 4 }}>
                          <strong>Telefone:</strong> {this.props.lab_phone}
                        </Typography>
                      )}
                      {this.props.lab_email && (
                        <Typography variant="body2" color="textSecondary" style={{ marginTop: 2 }}>
                          <strong>Email:</strong> {this.props.lab_email}
                        </Typography>
                      )}
                      {this.props.lab_site && (
                        <Typography variant="body2" color="textSecondary" style={{ marginTop: 2 }}>
                          <strong>Site:</strong> {this.props.lab_site}
                        </Typography>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
          );
        }
      }

      export default ResumoLateral;